import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles, WithStyles, Theme, createStyles } from '@material-ui/core/styles';
import { IOneplaceLibraryContextProp, withOneplaceLibraryContext } from 'oneplace-components';
import { IIncidentV2 } from '../../models/Incident';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import IncidentPersonFields from './IncidentPersonFields';

const styles = (theme: Theme) => createStyles({
    incidentInfo: {
        background: theme.palette.primary.main,
        color: '#FFF',
        padding: '16px',
        paddingBottom: '8px',
        display: 'flex',
        justifyContent: 'space-between'
    }
});


export interface IIncidentInfoProps
    extends WithStyles<typeof styles>, IOneplaceLibraryContextProp {
    surveyName: string;
    incident: IIncidentV2
}

const infoFn: React.FC<IIncidentInfoProps> = (props) => {

    const t = (key: string) => { return props.ctx.i18next.t(key) };

    return (
        <div>
            <div className={props.classes.incidentInfo}>
                <div>
                    <Typography variant="h5" color="inherit">
                        {`${t('customLabel_incident')}: ${props.surveyName}`}
                    </Typography>
                    <Typography variant="h6" color="inherit">
                        {`${t('customLabel_incident')} Type`} : {props.incident.type?.name}
                    </Typography>
                    <Typography variant="h6" color="inherit">
                        {t('customLabel_site')}: {props.incident.location || props.incident.site?.name}
                    </Typography>
                </div>
            </div>
            <div>
                {props.incident!.personFields &&
                    <Card >
                        <CardContent>
                            <div style={{ marginTop: '20px' }}>
                                <IncidentPersonFields personFields={props.incident.personFields} />
                            </div>
                        </CardContent>
                    </Card>
                }
            </div>
        </div>)
};

const IncidentV2Info = withStyles(styles)(withOneplaceLibraryContext(infoFn));
export { IncidentV2Info };